<template>
    <Fragment>
        <Heading>{{ $t('americanImport') }}</Heading>

        <BackendSelectField
            v-model="measureId"
            name-key="Description"
            value-key="FormOID"
            url="/measures/import/american"
            required
        />

        <AntButton
            icon="upload"
            :disabled="!measureId"
            type="primary"
            @click="importMeasure"
        >
            {{ $t('import') }}
        </AntButton>

        <Heading class="mt-3">
            {{ $t('americanDatabase') }}
        </Heading>
    </Fragment>
</template>

<script>
import BackendSelectField from '@/components/forms/elements/BackendSelectField.vue';
import Heading from '@/components/Heading.vue';
import { Button } from 'ant-design-vue';

export default {
    components: {
        AntButton: Button,
        Heading,
        BackendSelectField,
    },

    data: () => ({
        measureId: [],
    }),

    methods: {
        async importMeasure() {
            try {
                const { id, name } = await this.$http.post('/measures/import/american', {
                    id: this.measureId,
                });

                this.$notification.success({
                    message: this.$t('successfullyUploadedMeasure', { measure: name }),
                });

                this.$router.push({ name: 'measures.view', params: { id } });
            } catch {
                this.$notification.error({
                    message: this.$t('somethingWentWrongWithImport'),
                });
            }
        },
    },
};
</script>

<style>

</style>